module.exports = __webpack_public_path__ + "img/icon-in-review-active.a4d7e026.svg";